import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import advancedBodyweightTrainers from '../data/trainers/AdvancedBodyweightTrainers';
import './AdvancedBodyweightTrainers.css';

const AdvancedBodyweightTrainers = () => {
    const navigate = useNavigate();

    // Get advanced bodyweight trainers from the new trainers data file
    const advancedTrainersData = Object.values(advancedBodyweightTrainers);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('Advanced trainer selected:', trainer);

        // 🎵 PLAY ADVANCED TRAINER SELECTION SOUND
        soundManager.playSound('advancedSet2', 0.7);

        // Navigate to the advanced trainer page (uses same TrainerPage.js but with advanced data)
        navigate(`/advanced-trainer/${trainer.id}`);
    };

    // Handle back to train categories
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/train-categories');
    };

    return (
        <div className="advanced-bodyweight-trainers-container">
            {/* Green pulsating background */}
            <div className="green-pulsing-background"></div>

            <header className="advanced-bodyweight-trainers-header">
                <button
                    className="back-to-categories-button"
                    onClick={handleBackToCategories}
                >
                    ← Back to Categories
                </button>

                <div className="header-content">
                    <h1>Advanced Bodyweight Masters</h1>
                    <p>Elite coaches for advanced movement patterns and skills</p>
                    <div className="category-stats">
                        <span className="stat-badge">6 Elite Masters</span>
                        <span className="stat-badge">36 Advanced Programs</span>
                        <span className="stat-badge">Competition Level</span>
                    </div>
                </div>
            </header>

            <div className="advanced-trainers-grid">
                {advancedTrainersData.map((trainer) => (
                    <div
                        key={trainer.id}
                        className="advanced-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                    >
                        <div className="advanced-trainer-image-section">
                            <div
                                className="advanced-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}
                            >
                                <div className="experience-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        <div className="advanced-trainer-info-section">
                            <h3 className="advanced-trainer-name">{trainer.name}</h3>
                            <h4 className="advanced-trainer-specialization">{trainer.specialization}</h4>
                            <p className="advanced-trainer-description">{trainer.intro?.substring(0, 120)}...</p>

                            <div className="advanced-trainer-details">
                                <div className="detail-item">
                                    <span className="detail-icon">🏆</span>
                                    <span className="detail-text">{trainer.category} specialist</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-icon">📋</span>
                                    <span className="detail-text">{trainer.programs?.length || 6} Programs</span>
                                </div>
                            </div>

                            <div className="advanced-trainer-action">
                                <button className="select-advanced-trainer-button">
                                    Master Programs
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <footer className="advanced-bodyweight-trainers-footer">
                <div className="advanced-bodyweight-info">
                    <h3>🏆 Advanced Bodyweight Mastery</h3>
                    <div className="advanced-benefits-grid">
                        <div className="advanced-benefit-item">
                            <span className="benefit-icon">🤸‍♂️</span>
                            <div>
                                <strong>Elite Skills</strong>
                                <p>Master human flags, planches, and advanced holds</p>
                            </div>
                        </div>
                        <div className="advanced-benefit-item">
                            <span className="benefit-icon">⚡</span>
                            <div>
                                <strong>Dynamic Flow</strong>
                                <p>Learn seamless transitions and movement artistry</p>
                            </div>
                        </div>
                        <div className="advanced-benefit-item">
                            <span className="benefit-icon">🎯</span>
                            <div>
                                <strong>Competition Ready</strong>
                                <p>Train at levels that rival professional athletes</p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default AdvancedBodyweightTrainers;